import React, {Component} from 'react';
import Avatar from '@material-ui/core/Avatar';
import {Typography} from "@material-ui/core";
import {Color} from "../utis/Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import ButtonBase from "@material-ui/core/ButtonBase";
import {ChatMessageStatusType, MessageContentType} from "../utis/customEnum";
import CircularProgress from "@material-ui/core/CircularProgress";

const TextContentMaxWidth = 336
const ImageContentMaxWith = 200
const ImageContentMaxHeight = 200

class MessageItem extends Component {
	static defaultProps = {
		isMine: true
	}

	renderText(props) {
		return(
			<div style={{
				backgroundColor: props.isMine ? Color.theme : '#F2F2F2',
				borderBottomRightRadius: props.isMine ? 8 : 0,
				borderBottomLeftRadius: props.isMine ? 8 : 0,
				color: props.isMine ? Color.white : Color.black,
				maxWidth: TextContentMaxWidth,
				paddingLeft: 10,
				paddingTop: 10,
				paddingRight: 10,
				paddingBottom: 10,
				borderRadius: 8,
			}}>
				<Typography style={{
					wordWrap: 'break-word'
				}} variant={'body2'}>{props.content}</Typography>
			</div>
		)
	}

	renderImage(props) {
		let imgUrl = props.content
		let type = props.type
		let name = props.name
		const {classes} = props

		return(
			<div style={{display: 'flex', flexDirection: props.isMine ? 'row-reverse' : 'row', alignItems: 'center',
			}}>
				<ButtonBase onClick={() => {
					props.previewImageAction && props.previewImageAction(type, imgUrl, name)
				}} className={classes.imageButton}>
					<img className={classes.img} alt="complex" src={imgUrl} />
				</ButtonBase>

				{this.renderProgressView(props)}
			</div>

		)
	}

	renderPdf(props){
		let imgUrl = props.content
		let type = props.type
		let name = props.name
		const {classes} = props

		return(
			<div style={{display: 'flex', flexDirection: props.isMine ? 'row-reverse' : 'row', alignItems: 'center',
			}}>
				<ButtonBase onClick={() => {
					props.previewImageAction && props.previewImageAction(type, imgUrl, name)
				}} className={classes.imageButton}>
					<img className={classes.pdf} alt="complex" src={require('../assets/images/pdf.png')} />
					<Typography>{name}</Typography>
				</ButtonBase>

				{this.renderProgressView(props)}
			</div>

		)
	}

	renderMediaContent(props) {
		let type = props.type ? props.type.toLowerCase() : props.type
		if (type === MessageContentType.jpg ||
			type === MessageContentType.jpeg ||
			type === MessageContentType.png ||
			type === MessageContentType.bmp
		) {
			return this.renderImage(props)
		}else {
			return this.renderPdf(props)
		}
	}

	renderContent(props) {
		let type = props.type ? props.type.toLowerCase() : props.type
		if (type === MessageContentType.jpg ||
			type === MessageContentType.jpeg ||
			type === MessageContentType.png ||
			type === MessageContentType.bmp ||
			type === MessageContentType.pdf
		) {
			return this.renderMediaContent(props)
		}else {

			return this.renderText(props)
		}
	}

	renderProgressView(props) {
		let status = props.status
		if (status === ChatMessageStatusType.loading || status === ChatMessageStatusType.fail) {
			return  <CircularProgress size={20} style={{
				marginLeft: props.isMine ? 0 : 10,
				marginRight: props.isMine ? 10 : 0
			}}/>
		}else {
			return null
		}
	}

	renderFooter(props) {
		const {classes} = props
		let isFirstRecordChatItem = props.isFirstRecordChatItem
		let chatDateString = this.convertDateToString(props.chatDate)

		if (isFirstRecordChatItem) {
			return(
				<div className={classes.footer}>
					<Typography style={{color: Color.lightGray}}>{chatDateString}</Typography>
				</div>
			)
		}else {
			return null
		}
	}

	convertDateToString(chatDate) {
		const date = chatDate

		const year = date.getFullYear()

		let month = date.getMonth() + 1
		if (month >= 1 && month <= 9) {
			month = '0' + month
		}

		let day = date.getDate()
		if (day >= 1 && day <= 9) {
			day = '0' + day
		}

		let hour = date.getHours()
		if (hour >= 0 && hour <= 9) {
			hour = '0' + hour
		}

		let min = date.getMinutes()
		if (min >= 0 && min <= 9) {
			min = '0' + min
		}

		let sec = date.getSeconds()
		if (sec >= 0 && sec <= 9) {
			sec = '0' + sec
		}

		return (hour + ':' + min + ':' + sec + ' ' +  month + '/' + day + '/' + year + ' ')
	}

	render() {
		const props = this.props

		return(
			<React.Fragment>
				{this.renderFooter(props)}
				<div style={{
					width: '100%',
					display: 'flex',
					marginTop: 10,
					alignItems: 'flex-end',
					flexDirection: props.isMine ? 'row-reverse' : 'row',}}>
					<Avatar style={{
						width: 50,
						height: 50,
						marginRight: props.isMine ? 20 : 10,
						marginLeft: props.isMine ? 10 : 20,
						backgroundColor: props.isMine ? Color.extraLightGray : Color.theme,
						fontWeight: 'bold'
					}}>{props.userShortName}</Avatar>
					{this.renderContent(props)}

				</div>
			</React.Fragment>

		)
	}
}


const styles = (theme) => ({
	root: {

	},
	avatar: {
		width: 60,
		height: 60,
	},
	textContentBgView: {
	},
	imageButton: {
		width: ImageContentMaxWith,
		height: ImageContentMaxHeight,
		minHeight: 30,
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column'
	},
	img: {
		margin: 'auto',
		display: 'block',
		width: ImageContentMaxWith,
		height: ImageContentMaxHeight,
		objectFit: 'contain',
		justifyContent: 'center',
		alignItems: 'center'
	},
	pdf: {
		width: 100,
		height: 100,
		objectFit: 'contain',
		marginBottom: 10,
	},
	footer: {
		width: '100%',
		height: 30,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: 10
	}
})

export default withStyles(styles)(MessageItem)
